module.exports = __webpack_public_path__ + "img/icon_success@2x.16dc9d52.png";